module.exports = __webpack_public_path__ + "img/gys_18@2x.11a77c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/cooperation/gys_18@2x.png
// module id = GJ5r
// module chunks = 0